import { useCallback, useSyncExternalStore } from 'react';
import { getLocale, setLocale, subscribe, translate, type Vars } from './core';
import type { Locale } from './dict';

export function useLocale(): [Locale, (l: Locale) => void] {
  const l = useSyncExternalStore(subscribe, getLocale, getLocale);
  return [l, setLocale];
}

/** `const t = useT(); t('common.save')` — render lại khi đổi ngôn ngữ, không tải lại trang. */
export function useT(): (key: string, vars?: Vars) => string {
  const l = useSyncExternalStore(subscribe, getLocale, getLocale);
  return useCallback((key, vars) => translate(l, key, vars), [l]);
}
